import axios from "axios";
import { API_URL, PASSWORD, USERNAME } from "../constants";
import { incrementCartCount, showLoader, showProdAddedSuccessPopup } from "../store/action";
import Swal from 'sweetalert2'

export const getSiteId = () => {
  const urlPath = window.location.pathname.substr(1,);
  const parts = urlPath.split('/');
  const siteId = parts[0];
  return siteId;
}

export const getApiAction = async (endpoint, getData = {},retry, dispatch) => {
    try {
      dispatch(showLoader(true));

      const bookingReferenceId = localStorage.getItem('booking_reference_id') || '';
      const response = await axios.get(API_URL + endpoint, {
        auth: {
          username: USERNAME,
          password: PASSWORD,
        },
        headers: {
          'BOOKING-REFERENCE-ID': bookingReferenceId,
          'OUTLET-UNIQUE-ID': getSiteId()
        }
      });
      dispatch(showLoader(false));

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error.code);
        if(typeof error.code !== 'undefined' && error.code == 'ERR_NETWORK'){
          dispatch(showLoader(false));
          if(!Swal.isVisible()){
            Swal.fire({
              icon: "error",
              title: "¡Error de red!",
              text: "Por favor, compruebe la conexión y vuelva a intentarlo.",
              showCancelButton: true,
              confirmButtonText: "actualizer",
              cancelButtonText: "cancelar"
            }).then((result) => {
              if (result.isConfirmed) {
                getApiAction(endpoint, getData, retry, dispatch);
              }
            });
          }
        }else if(typeof error.code !== 'undefined'  && error.code == 'ECONNABORTED'){
          if(retry < 2){
            retry += 1;
            setTimeout(() => {
              getApiAction(endpoint, getData, retry, dispatch);
            }, 1500);
          
          }else{
            dispatch(showLoader(false));
            if(!Swal.isVisible()){
              Swal.fire({
                icon: "error",
                title: "¡Error de red!",
                text: "Por favor, compruebe la conexión y vuelva a intentarlo.",
                showCancelButton: true,
                confirmButtonText: "actualizer",
                cancelButtonText: "cancelar"
              }).then((result) => {
                if (result.isConfirmed) {
                  getApiAction(endpoint, getData, retry, dispatch);
                }
              });
            }
          }
        }else{
            dispatch(showLoader(false));
            return error;
        }
    } 
};
export const postApiAction = async (endpoint, postData = {}, retry, dispatch) => {
  dispatch(showLoader(true));
    try {
      const bookingReferenceId = localStorage.getItem('booking_reference_id') || '';
      const response = await axios.post(API_URL + endpoint, postData, {
        auth: {
          username: USERNAME,
          password: PASSWORD,
        },
        headers: {
          'BOOKING-REFERENCE-ID': bookingReferenceId,
          'OUTLET-UNIQUE-ID': getSiteId()
        }
      });
      
      dispatch(showLoader(false));

      return response.data;
    } catch (error) {
      console.error("Error fetching data----:", error);
      //console.error("Error fetching data:", error.response.data.message);
      //if(typeof error.code !== 'undefined' && error.code == 'ERR_NETWORK'){
        if(typeof error.code !== 'undefined' && error.code == 'ERR_NETWORK'){
          dispatch(showLoader(false));
          if(!Swal.isVisible()){
            Swal.fire({
              icon: "error",
              title: "¡Error de red!",
              text: "Por favor, compruebe la conexión y vuelva a intentarlo.",
              showCancelButton: true,
              confirmButtonText: "actualizer",
              cancelButtonText: "cancelar"
            }).then((result) => {
              if (result.isConfirmed) {
                postApiAction(endpoint, postData, retry, dispatch);
              }
            });
          }
        }else if(typeof error.code !== 'undefined'  && error.code == 'ECONNABORTED'){
          if(retry < 3){
            retry++;
            setTimeout(() => {
              postApiAction(endpoint, postData, retry, dispatch);
            }, 1500);
          
          }else{
            if(!Swal.isVisible()){
              Swal.fire({
                icon: "error",
                title: "¡Error de red!",
                text: "Por favor, compruebe la conexión y vuelva a intentarlo.",
                showCancelButton: true,
                confirmButtonText: "actualizer",
                cancelButtonText: "cancelar"
              }).then((result) => {
                if (result.isConfirmed) {
                  postApiAction(endpoint, postData, retry, dispatch);
                }
              });
            }
          }
        }else{
            dispatch(showLoader(false));
            return error;
        }
    }
};

export const putApiAction = async (endpoint, postData = {}, dispatch) => {
  dispatch(showLoader(true));
    try {

      const bookingReferenceId = localStorage.getItem('booking_reference_id') || '';
      const response = await axios.put(API_URL + endpoint, postData, {
        auth: {
          username: USERNAME,
          password: PASSWORD,
        },
        headers: {
          'BOOKING-REFERENCE-ID': bookingReferenceId,
          'OUTLET-UNIQUE-ID': window.location.pathname.substr(1,)
        }
      });
      
      dispatch(showLoader(false));

      return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(showLoader(false));
        return [];
      }
};

export const productAddedMain = async (productName, productId, price, notes, attribute_id, modifier_id, dispatch) => {
  // e.preventDefault();
  let formData = {
    product_id: parseInt(productId, 10),
    quantity: 1,
    notes: notes,
    price: price,
    attribute_id: attribute_id,
    modifier_id: modifier_id,
  };
  dispatch(incrementCartCount());
  let resp = await postApiAction("cart/add", formData,  0, dispatch);
  if(resp?.response?.data?.message){
    return resp;
  }else{
    dispatch(showProdAddedSuccessPopup(true, productName));
    setTimeout(() => {
      dispatch(showProdAddedSuccessPopup(false, ''));
    }, 1000);
  }
  return resp;
};

